// /lockers/lockers_order/queryParkingInfo
import request from '@/utils/request';
export default {

  /**
   * 查询
   */
  query(data) {
    return request({
      url: '/ipark/lockers/lockers_order/queryParkingInfo',
      method: 'POST',
      data
    })
  },
  fetchPayDtl(id) {
    return request({
      url: '/ipark/pay_order/get/' + id,
      method: 'GET'
    })
  },
}



// WEBPACK FOOTER //
// ./src/api/ground-parking/park-record.js